module.exports = __webpack_public_path__ + "static/media/logo-black-transparent.6346e0d0.png";